import React from 'react';
import Settings_nav from './Settings_nav';
import Header from './Header';
import axios from 'axios';
import { Container, Row, Col, Form, Button, ProgressBar } from "react-bootstrap";
import { useNetworkState } from 'react-use';
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import Swal from 'sweetalert2';
import ReactLoading from 'react-loading';
import config from "../../config";
import Footer from './Footer';
import { CornerLeftUp, CornerUpLeft } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';

const User_kyc = () => {
    const [searchParams] = useSearchParams();
    const urlstatus = searchParams.get("status")
    React.useEffect(() => {
        const status = searchParams.get("status");
      if (status === "success") {
        verifyOtp()
        
        } 
      }, []);
  let userDetail = localStorage.getItem('ship_rocket_user');
        console.log("userDetail====", userDetail);
        let userData = {};
        if (userDetail != null) {
          userData = JSON.parse(userDetail)
        }
        const Toast = Swal.mixin({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 5000
        })
    const isOnline = useNetworkState();
    const [state, setState] = React.useState({ aadhar_number: "" });
    const [refId, setrefId] = React.useState({ ref_id: "" });
    const [optstate, setOtp] = React.useState('');
    const [userstate, setUserState] = React.useState({});
    const [companystate, setcompanyState] = React.useState({});
    const [gstonoff, setgstonoff] = React.useState(0);
    const [aadharNumber, setAadharNumber] = React.useState('');
    const [otpresponsestate, setotpresponse] = React.useState({ req_id: '', task_id: '' });
    const [gststate, setgstState] = React.useState({ gst_number: "" });
    const [inputvisible, setinputvisibletState] = React.useState(false);
    const [otherpartvisible, setotherpartvisibletState] = React.useState(false);

    const [formData, setFormData] = React.useState({
        aadharNumber: '',
        panNumber: '',
        gstNumber: '',
        aadharFrontImage: null,
        aadharBackImage: null,
        panFrontImage: null,
        gstImage: null,
        accountname: '',
        accountNumber: '',
        accountifsc: '',
        cancelchequeimage: null,
        insta_link: '',
        facebook_link: '',
        marketplace_link: '',
        website_link: '',
        others_link: ''
    });
    const [errors, setErrors] = React.useState({});
    const [btnstate, setbtnstate] = React.useState(false);
    const [otpbtnstate, setotpbtnstate] = React.useState(false);
    const [verifyotpbtnstate, setverifyotpbtnstate] = React.useState(false);
    const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        const homeSection = document.querySelector('.home-section');
        if (homeSection) {
            homeSection.classList.toggle('sidebar-closed');
        }
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setErrors({});
    };

    const handleFileChange = (e, type) => {
        setFormData({ ...formData, [type]: e.target.files[0] });
        setErrors({});
    };

    const handleSubmit = async (e) => {
        setbtnstate(true);
        e.preventDefault();
        let errors = {};
        let isValid = true;

        // if (!formData.aadharNumber) {
        //     errors.aadharNumber = 'Aadhar Number is required';
        //     isValid = false;
        // } else if (formData.aadharNumber.length !== 12) {
        //     errors.aadharNumber = 'Aadhar Number must be exactly 12 digits';
        //     isValid = false;
        // }

        if (!formData.panNumber) {
            errors.panNumber = 'PAN Number is required';
            isValid = false;
        } else if (formData.panNumber.length > 10) {
            errors.panNumber = 'PAN Number must not exceed 10 digits';
            isValid = false;
        }

        if (formData.gstNumber && formData.gstNumber.length > 15) {
            errors.gstNumber = 'GST Number must not exceed 15 digits';
            isValid = false;
        }

        if (gstonoff == 1 && !formData.gstNumber) {
            errors.gstNumber = 'GST Number is required';
            isValid = false;
        }

        // if (!formData.aadharFrontImage) {
        //     errors.aadharFrontImage = 'Front side of Aadhar card is required';
        //     isValid = false;
        // }

        // if (!formData.aadharBackImage) {
        //     errors.aadharBackImage = 'Back side of Aadhar card is required';
        //     isValid = false;
        // }

        if (!formData.panFrontImage) {
            errors.panFrontImage = 'Front side of PAN card is required';
            isValid = false;
        }

        if (!formData.accountname) {
            errors.accountname = 'Account Name is required';
            isValid = false;
        }

        if (!formData.accountNumber) {
            errors.accountNumber = 'Account Number is required';
            isValid = false;
        }

        if (!formData.accountifsc) {
            errors.accountifsc = 'IFSC Code is required';
            isValid = false;
        }

        if (!formData.cancelchequeimage) {
            errors.cancelchequeimage = 'Cancel Cheque Image is required';
            isValid = false;
        }

        if (!formData.insta_link && !formData.facebook_link && !formData.marketplace_link && !formData.website_link && !formData.others_link) {
            errors.links = 'At least one link (Instagram, Facebook, Marketplace, Website, or Other) is required';
            isValid = false;
        }

        if (!isValid) {
            setErrors(errors);
            setbtnstate(false);
            return;
        }

        const data = new FormData();
        data.append('customer_id', userData.customer_id);
        data.append('aadharNumber', formData.aadharNumber);
        data.append('panNumber', formData.panNumber.toUpperCase());
        data.append('gstNumber', formData.gstNumber?formData.gstNumber.toUpperCase():"");
        data.append('aadharFrontImage', formData.aadharFrontImage);
        data.append('aadharBackImage', formData.aadharBackImage);
        data.append('panFrontImage', formData.panFrontImage);
        data.append('gstImage', formData.gstImage);
        data.append('accountname', formData.accountname);
        data.append('accountNumber', formData.accountNumber);
        data.append('accountifsc', formData.accountifsc);
        data.append('cancelchequeimage', formData.cancelchequeimage);
        data.append('insta_link', formData.insta_link);
        data.append('facebook_link', formData.facebook_link);
        data.append('marketplace_link', formData.marketplace_link);
        data.append('website_link', formData.website_link);
        data.append('others_link', formData.others_link);

        try {
            let full_api = config.apiUrl + `/user/add_customer_proof`;
            axios.post(full_api, data, { headers: config.headers }).then((res) => {
                if (res.data.status == true) {
                    Toast.fire({
                        background: "#3659cd",
                        type: 'success',
                        title: res.data.message,
                        color: "white"
                    });
                    user();
                    setbtnstate(false);
                    window.location.reload();
                } else {
                    Toast.fire({
                        background: "#a61c09",
                        type: 'success',
                        title: res.data.message,
                        color: "white"
                    });
                    setbtnstate(false);
                }
            });
        } catch (error) {
            console.error('Error:', error);
            setbtnstate(false);
        }
    };

    React.useEffect(() => {
        user();
    }, []);

    const user = () => {
        let dataToSend = {};
        let url = config.apiUrl + '/user/find_customer_detail';
        axios.post(url, dataToSend, { headers: config.headers })
            .then((res) => {
                setUserState(res.data.output);
                setcompanyState(res.data.company);
                setFormData({
                    ...formData,
                    aadharNumber: res.data.output.aadhaar_number,
                    panNumber: res.data.output.pan_number,
                    gstNumber: res.data.output.gst_number,
                    aadharFrontImage: res.data.output.aadharFrontImage,
                    aadharBackImage: res.data.output.aadharBackImage,
                    panFrontImage: res.data.output.panFrontImage,
                    gstImage: res.data.output.gstImage,
                    accountname: res.data.output.bank_details.account_name,
                    accountNumber: res.data.output.bank_details.bankAccount,
                    accountifsc: res.data.output.bank_details.ifsc,
                    cancelchequeimage: res.data.output.bank_details.cancelchequeimage,
                    insta_link: res.data.output.insta_link,
                    facebook_link: res.data.output.facebook_link,
                    marketplace_link: res.data.output.marketplace_link,
                    website_link: res.data.output.website_link,
                    others_link: res.data.output.others_link
                });
                if (res.data.output.gst_number == undefined || res.data.output.gst_number == "") {
                    setgstonoff(0);
                } else {
                    setgstonoff(1);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const changeStatus = (e) => {
        if (e.target.checked) {
            setgstonoff(1);
        } else {
            setgstonoff(0);
            setFormData({ ...gstonoff, gstImage: "", gstNumber: "" });
        }
    };

    const sendOtp = () => {
        setotpbtnstate(true);
        let errors = {};
        let isValid = true;

        if (!formData.aadharNumber) {
            errors.aadharNumber = 'Aadhar Number is required';
            isValid = false;
        } else if (formData.aadharNumber.length !== 12) {
            errors.aadharNumber = 'Aadhar Number must be exactly 12 digits';
            isValid = false;
        }

        if (!formData.aadharFrontImage) {
            errors.aadharFrontImage = 'Front side of Aadhar card is required';
            isValid = false;
        }

        if (!formData.aadharBackImage) {
            errors.aadharBackImage = 'Back side of Aadhar card is required';
            isValid = false;
        }

        if (!isValid) {
            setErrors(errors);
            setotpbtnstate(false);
            return;
        }

        let dataToSend = {
            aadharNumber: formData.aadharNumber
        };
        let url = config.apiUrl + '/user/send_aadhar_otp';
        axios.post(url, dataToSend, { headers: config.headers })
            .then((res) => {
                if (res.data.status == true) {
                    setotpresponse({ req_id: res.data.req_id, task_id: res.data.task_id });
                    setinputvisibletState(true);
                    Toast.fire({
                        background: "#3659cd",
                        type: 'success',
                        title: res.data.message,
                        color: "white"
                    });
                    setotpbtnstate(false);
                } else {
                    Toast.fire({
                        background: "#a61c09",
                        type: 'success',
                        title: res.data.message,
                        color: "white"
                    });
                    setotpbtnstate(false);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const verifyOtp = () => {
        setverifyotpbtnstate(true);
        let dataToSend = {
            otp: optstate,
            req_id: otpresponsestate.req_id,
            task_id: otpresponsestate.task_id,

        };
        let url = config.apiUrl + '/user/verify_aadhar_otp';
        axios.post(url, dataToSend, { headers: config.headers })
            .then((res) => {
                if (res.data.status == true) {
                  setotherpartvisibletState(true);
                //   setFormData({aadharNumber:res.data.output[0].aadhaar_number , aadharBackImage:res.data.output[0].aadharBackImage , aadharFrontImage:res.data.output[0].aadharFrontImage})
                    // Toast.fire({
                    //     background: "#3659cd",
                    //     type: 'success',
                    //     title: res.data.message,
                    //     color: "white"
                    // });
                    setverifyotpbtnstate(false);
                } else {
                    // Toast.fire({
                    //     background: "#a61c09",
                    //     type: 'success',
                    //     title: res.data.message,
                    //     color: "white"
                    // });
                    setverifyotpbtnstate(false);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const initiateDigilockerVerification = async () => {
        try {
            let errors = {};
            let isValid = true;
            if (!formData.aadharNumber) {
                errors.aadharNumber = 'Aadhar Number is required';
                isValid = false;
            } else if (formData.aadharNumber.length !== 12) {
                errors.aadharNumber = 'Aadhar Number must be exactly 12 digits';
                isValid = false;
            }
    
            if (!formData.aadharFrontImage) {
                errors.aadharFrontImage = 'Front side of Aadhar card is required';
                isValid = false;
            }
    
            if (!formData.aadharBackImage) {
                errors.aadharBackImage = 'Back side of Aadhar card is required';
                isValid = false;
            }
    
            if (!isValid) {
                setErrors(errors);
                setotpbtnstate(false);
                return;
            }
            setotpbtnstate(true);
            const data = new FormData();
            data.append('customer_id', userData.customer_id);
            data.append('aadharNumber', formData.aadharNumber);
            data.append('aadharFrontImage', formData.aadharFrontImage);
            data.append('aadharBackImage', formData.aadharBackImage);
           
            let url = config.apiUrl + '/user/initiate_digilocker';
          axios.post(url, data, { headers: config.headers })
          .then((res) => {
              if (res.data.success == true) {
                window.location.href = res.data.sdk_url;
                  setinputvisibletState(true);
                 
                  setotpbtnstate(false);
              } else {
                  Toast.fire({
                      background: "#a61c09",
                      type: 'success',
                      title: "Failed to start Aadhaar verification",
                      color: "white"
                  });
                  setotpbtnstate(false);
              }
          })
          .catch((error) => {
              console.log(error);
              Toast.fire({
                background: "#a61c09",
                type: 'success',
                title: "Error initiating DigiLocker verification.",
                color: "white"
            });
            
              setotpbtnstate(false);
          });
        } catch (err) {
          console.error("Zoop error:", err);
          Toast.fire({
            background: "#a61c09",
            type: 'success',
            title: "Error initiating DigiLocker verification.",
            color: "white"
        });
        
         
          setotpbtnstate(false);
        }
      };

    return (
        <div>
            <Header />
            <div class="page-wrapper pinned">
                <div class="main-container">
                    <div className='app-container'>
                        <div class="app-body">
                            <div class="container-fluid">
                                <div class="mob_nav">
                                    <div class=" d-flex justify-content-start ">
                                        <a href="javascript:window.history.back();" class=""><i class="bi bi-arrow-left"></i></a>
                                        <h2>Customer KYC</h2>
                                    </div>
                                </div>
                                <div class="row justify-content-between">
                                    <div class="col-12 col-md-4 desk_nav">
                                        <div class="d-flex">
                                            <a href="javascript:window.history.back();" class="back_btn"><i class="bi bi-arrow-90deg-left"></i></a>
                                            <h2>Customer KYC</h2>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 col-md-3 left_sub_menu_bx mb_display_none">
                                        <Settings_nav value={3} />
                                    </div>
                                    <div class="col-12 col-md-9">
                                        <div>
                                            {userstate.alert_kyc == 2 ?
                                                <div class="alert alert-success">
                                                    <strong>Verified!</strong> Your KYC has been verified.
                                                </div> : userstate.alert_kyc == 1 ? <div class="alert alert-warning">
                                                    <strong>Pending!</strong> Your details are under review. Our team will update you soon.
                                                </div> : ""}
                                        </div>
                                        <div class="card border-0 shadow-sm">
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-12 col-md-12 mb-3">
                                                        <label for="" class="form-label">Aadhar Card Number <span class="text-danger">*</span></label>
                                                        {urlstatus==undefined?
                                                        <input type="text" class="form-control" id="text" placeholder="Enter Aadhar Card Number" name="aadharNumber" 
                                                            value={formData.aadharNumber}
                                                            onChange={handleChange} />
                                                            :
                                                        <input type="text" class="form-control" style={{background:"rgb(244 240 240)"}} id="text" placeholder="Enter Aadhar Card Number" name="aadharNumber" 
                                                            value={formData.aadharNumber}
                                                            onChange={handleChange} readOnly />}
                                                        {errors.aadharNumber && <div className="text-danger mt-2">{errors.aadharNumber}</div>}
                                                    </div>
                                                    <div class="col-12 col-md-6 mb-3">
                                                        <label for="" class="form-label">Aadhar Card Front Image upload <span class="text-danger">*</span></label>
                                                        {formData.aadharFrontImage && formData.aadharFrontImage != "" ? (
                                                            <a href={formData.aadharFrontImage} target="_blank" rel="noopener noreferrer">
                                                                View Document
                                                            </a>
                                                        ) : (
                                                            ""
                                                        )}
                                                        {urlstatus==undefined?
                                                        <input className='form-control'
                                                            type="file"
                                                            accept=".jpg, .jpeg, .png, .pdf"
                                                            onChange={(e) => handleFileChange(e, 'aadharFrontImage')}
                                                        />:""}
                                                        {errors.aadharFrontImage && <div className="text-danger mt-2">{errors.aadharFrontImage}</div>}
                                                    </div>
                                                    <div class="col-12 col-md-6 mb-3">
                                                        <label for="" class="form-label">Aadhar Card Back Image upload <span class="text-danger">*</span></label>
                                                        {formData.aadharBackImage && formData.aadharBackImage != "" ? (
                                                            <a href={formData.aadharBackImage} target="_blank" rel="noopener noreferrer">
                                                                View Document
                                                            </a>
                                                        ) : (
                                                            ""
                                                        )}
                                                        {urlstatus==undefined?
                                                        <input className='form-control'
                                                            type="file"
                                                            accept=".jpg, .jpeg, .png, .pdf"
                                                            onChange={(e) => handleFileChange(e, 'aadharBackImage')}
                                                        />:""}
                                                        {errors.aadharBackImage && <div className="text-danger mt-2">{errors.aadharBackImage}</div>}
                                                    </div>
                                                    {userstate.alert_kyc === 0 && urlstatus==undefined && (
                                                        <>
                                                            <div className=''>
                                                                {otpbtnstate == true ? <div className='' style={{ marginLeft: "60px" }}><ReactLoading type={"spin"} color={"#0d6efd"} height={40} width={30} /></div> : 
                                                                // <button className='btn btn-primary' onClick={(e) => sendOtp(e)}>Verify Aadhaar With OTP</button>
                                                                
                                                                <button className='btn btn-primary' onClick={initiateDigilockerVerification}>Verify Aadhaar With DigiLocker</button>
                                                                }
                                                            </div>
                                                            {/* {inputvisible && (
                                                                <div class="col-12 col-md-12 mb-3 mt-5">
                                                                    <input type="email" class="form-control" id="email" placeholder="Enter OTP Number"
                                                                        onChange={(e) => setOtp(e.target.value)} />
                                                                    <div className=' mt-2'>
                                                                        {verifyotpbtnstate == true ? <div className='' style={{ marginLeft: "60px" }}><ReactLoading type={"spin"} color={"#0d6efd"} height={40} width={30} /></div> : <button className='btn btn-primary' onClick={(e) => verifyOtp(e)}>Submit</button>}
                                                                    </div>
                                                                </div>
                                                            )} */}
                                                        </>
                                                    )}
                                                    {(userstate.alert_kyc === 1 || userstate.alert_kyc === 2 || otherpartvisible) && (
                                                        <>
                                                            <div class="col-12 col-md-12 mb-3 mt-5">
                                                                <label for="" class="form-label">PAN Card Number <span class="text-danger">* (Company PAN for LLP and Pvt Ltd.)</span></label>
                                                                <input type="email" class="form-control" id="email" placeholder="Enter PAN Number" name="panNumber"
                                                                    value={formData.panNumber}
                                                                    onChange={handleChange} />
                                                                {errors.panNumber && <div className="text-danger mt-2">{errors.panNumber}</div>}
                                                            </div>
                                                            <div class="col-12 col-md-12 mb-3">
                                                                <label for="" class="form-label">PAN Card Image upload <span class="text-danger">*</span></label>
                                                                {formData.panFrontImage && formData.panFrontImage != "" ? (
                                                                    <a href={formData.panFrontImage} target="_blank" rel="noopener noreferrer">
                                                                        View Document
                                                                    </a>
                                                                ) : (
                                                                    ""
                                                                )}
                                                                <input className='form-control'
                                                                    type="file"
                                                                    accept=".jpg, .jpeg, .png, .pdf"
                                                                    onChange={(e) => handleFileChange(e, 'panFrontImage')}
                                                                />
                                                                {errors.panFrontImage && <div className="text-danger mt-2">{errors.panFrontImage}</div>}
                                                            </div>
                                                            <div class="col-12 col-md-12  mt-5">
                                                                <label for="" class="form-label">Do you have GST?
                                                                    <div class="form-check form-switch">
                                                                        <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked"
                                                                            checked={gstonoff == 1} onChange={(e) => changeStatus(e)}
                                                                        />
                                                                    </div>
                                                                </label>
                                                            </div>
                                                            {gstonoff == 1 ?
                                                                <>
                                                                    <div class="col-12 col-md-12 mb-3">
                                                                        <label for="" class="form-label">GST Number <span class="text-danger">*</span></label>
                                                                        <input type="text" class="form-control form-control-lg" placeholder="Enter GST Number" required
                                                                            name="gstNumber"
                                                                            value={formData.gstNumber}
                                                                            onChange={handleChange} />
                                                                        {errors.gstNumber && <div className="text-danger mt-2">{errors.gstNumber}</div>}
                                                                    </div>
                                                                    <div class="col-12 col-md-12 mb-3">
                                                                        <label for="" class="form-label">GST Certificate Image upload <span class="text-danger">*</span></label>
                                                                        {formData.gstImage && formData.gstImage != "" ? (
                                                                            <a href={formData.gstImage} target="_blank" rel="noopener noreferrer">
                                                                                View Document
                                                                            </a>
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                        <input className='form-control'
                                                                            type="file"
                                                                            accept=".jpg, .jpeg, .png, .pdf"
                                                                            onChange={(e) => handleFileChange(e, 'gstImage')}
                                                                        />
                                                                        {errors.gstImage && <div className="text-danger mt-2">{errors.gstImage}</div>}
                                                                    </div>
                                                                </>
                                                                : ""}
                                                            <div className='col-12 mt-5'>
                                                                <h2>Bank Details</h2>
                                                            </div>
                                                            <div class="col-12 col-md-6 mb-3 mt-3">
                                                                <label for="" class="form-label">Account Holder Name: <span class="text-danger">*</span></label>
                                                                <input type="email" class="form-control" id="email" placeholder="Enter Account Holder Name" name="accountname"
                                                                    value={formData.accountname}
                                                                    onChange={handleChange} />
                                                                {errors.accountname && <div className="text-danger mt-2">{errors.accountname}</div>}
                                                            </div>
                                                            <div class="col-12 col-md-6 mb-3 mt-3">
                                                                <label for="" class="form-label">Account Number <span class="text-danger">*</span></label>
                                                                <input type="email" class="form-control" id="email" placeholder="Enter Account Number" name="accountNumber"
                                                                    value={formData.accountNumber}
                                                                    onChange={handleChange} />
                                                                {errors.accountNumber && <div className="text-danger mt-2">{errors.accountNumber}</div>}
                                                            </div>
                                                            <div class="col-12 col-md-6 mb-3">
                                                                <label for="" class="form-label">IFSC Code <span class="text-danger">*</span></label>
                                                                <input type="email" class="form-control" id="email" placeholder="Enter Branch IFSC Code" name="accountifsc"
                                                                    value={formData.accountifsc}
                                                                    onChange={handleChange} />
                                                                {errors.accountifsc && <div className="text-danger mt-2">{errors.accountifsc}</div>}
                                                            </div>
                                                            <div class="col-12 col-md-6 mb-3">
                                                                <label for="" class="form-label">Upload Cancel Cheque Copy <span class="text-danger">*</span></label>
                                                                {formData.cancelchequeimage && formData.cancelchequeimage != "" ? (
                                                                    <a href={formData.cancelchequeimage} target="_blank" rel="noopener noreferrer">
                                                                        View Document
                                                                    </a>
                                                                ) : (
                                                                    ""
                                                                )}
                                                                <input className='form-control'
                                                                    type="file"
                                                                    accept=".jpg, .jpeg, .png, .pdf"
                                                                    onChange={(e) => handleFileChange(e, 'cancelchequeimage')} />
                                                                {errors.cancelchequeimage && <div className="text-danger mt-2">{errors.cancelchequeimage}</div>}
                                                            </div>
                                                            <div className='col-12 mt-5'>
                                                                <h2>Please provide a link to your online store:</h2>
                                                            </div>
                                                            <div className='col-12 col-md-12 mt-3 '>  {errors.links && <div className="text-danger mt-2">{errors.links}</div>}</div>
                                                            <div class="col-12 col-md-6 mb-3 ">
                                                                <label for="" class="form-label">Instagram: </label>
                                                                <input type="text" class="form-control" id="email" placeholder="Enter Instagram Link" name="insta_link"
                                                                    value={formData.insta_link}
                                                                    onChange={handleChange} />
                                                            </div>
                                                            <div class="col-12 col-md-6 mb-3 ">
                                                                <label for="" class="form-label">Facebook </label>
                                                                <input type="text" class="form-control" id="email" placeholder="Enter Facebook Link" name="facebook_link"
                                                                    value={formData.facebook_link}
                                                                    onChange={handleChange} />
                                                            </div>
                                                            <div class="col-12 col-md-6 mb-3">
                                                                <label for="" class="form-label">Marketplace (Amazon/Flipkart/Myntra,etc.) </label>
                                                                <input type="text" class="form-control" id="email" placeholder="Enter Marketplace Link" name="marketplace_link"
                                                                    value={formData.marketplace_link}
                                                                    onChange={handleChange} />
                                                            </div>
                                                            <div class="col-12 col-md-6 mb-3">
                                                                <label for="" class="form-label">Own Website</label>
                                                                <input type="text" class="form-control" id="email" placeholder="Enter Own Website Link" name="website_link"
                                                                    value={formData.website_link}
                                                                    onChange={handleChange} />
                                                            </div>
                                                            <div class="col-12 col-md-6 mb-3">
                                                                <label for="" class="form-label">Others</label>
                                                                <input type="text" class="form-control" id="email" placeholder="Enter Others Link" name="others_link"
                                                                    value={formData.others_link}
                                                                    onChange={handleChange} />
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                                {(userstate.alert_kyc === 1  || otherpartvisible) && (
    <div class="">
        {btnstate == true ? (
            <div className='' style={{ marginLeft: "60px" }}>
                <ReactLoading type={"spin"} color={"#0d6efd"} height={40} width={30} />
            </div>
        ) : (
            <a onClick={(e) => handleSubmit(e)} class="btn btn-primary">Update</a>
        )}
    </div>
)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default User_kyc;
